import React from "react";
import BusinessRoutes from "./businessRoutes";
import CoOwnerRoutes from "./coOwnerRoutes";
import { Routes, Route } from "react-router-dom";
import NotFoundPage from "../components/errors/404";
import BusinessRegisterForm from "../components/account/businessRegister";
import AuthAwareLogin from "../components/landing/AuthAwareLogin";
import AuthAwareLanding from "../components/landing/AuthAwareLanding";
import EmployeeRoutes from "./employeeRoutes";
import CustomerRoutes from "./customerRoutes";
import BankerRoutes from "./bankerRoutes";
import UserRegisterForm from "../components/account/userRegister";
import AdminRoutes from "./adminRoutes";
import ForgotPasswordForm from "../components/account/forgotPassword";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AuthAwareLanding />} />
      <Route path="/register-business" element={<BusinessRegisterForm />} />
      <Route path="/login" element={<AuthAwareLogin />} />
      <Route path="/forgot-password" element={<ForgotPasswordForm />} />
      <Route path="/register-co-owner" element={<UserRegisterForm />} />
      <Route path="/register-employee" element={<UserRegisterForm />} />
      <Route path="/register-customer" element={<UserRegisterForm />} />
      <Route path="/register-banker" element={<UserRegisterForm />} />
      {/* Authenticated Role-based Routes */}
      {BusinessRoutes}
      {CoOwnerRoutes}
      {EmployeeRoutes}
      {CustomerRoutes}
      {BankerRoutes}
      {AdminRoutes}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
